import {Button} from "@mantine/core";
import {Modal} from "@mantine/core";
import { Check as IconCheck, FloppyDisk as IconDeviceFloppy } from "@phosphor-icons/react";
import {numFormat} from "../../utils/formatters.ts";

export type StatChanges = {
  name: string,
  mode: 'cargo',
  prevWeight: number,
  newWeight: number,
  prevVolume: number,
  newVolume: number
} | {
  name: string,
  mode: 'container',
  prevVolume: number,
  newVolume: number,
  prevWeight?: number,
  newWeight?: number
}

export const StatUpdateDialog = ({changes, clear, save}: {
  changes: StatChanges[],
  clear: () => void,
  save: () => void,
}) => {


  return (
    <Modal title="Stats Updated" opened={changes.length > 0} onClose={clear}>

      <p>The following entities have different stats (weight/volume) than what was saved. The calculator has been updated with the latest values.</p>
      <ul>
        {changes.map(entity => <li key={entity.name}>{entity.name}<ul>
          {entity.prevWeight && entity.newWeight && entity.prevWeight !== entity.newWeight ? <li key="weight">{entity.mode === 'cargo' ? 'Weight' : 'Weight Cap'}: {numFormat.format(entity.prevWeight)} -&gt; {numFormat.format(entity.newWeight)}</li> : null}
          {entity.prevVolume !== entity.newVolume ? <li key="volume">{entity.mode === 'cargo' ? 'Volume' : 'Volume Cap'}: {numFormat.format(entity.prevVolume)} -&gt; {numFormat.format(entity.newVolume)}</li> : null}
        </ul></li>)}
      </ul>
      <div>
        <Button variant="subtle" leftSection={<IconCheck size={16}/>} onClick={clear}>OK</Button>
        <Button leftSection={<IconDeviceFloppy size={16}/>} onClick={save} autoFocus>Save the changes</Button>
      </div>
    </Modal>
  )
}
